function emptyParsed() {
    return {
        isFlat: false,
        sites: {
            top_level: {},
            top_5_bandwidth: [],
            children: {},
            parent_map: {},
        },
        circuits: null,
    };
}

// Utility helpers for decoding shaper_children CBOR payloads into plain JS objects.
function normalizeCborValue(value) {
    if (value instanceof Map) {
        const obj = {};
        value.forEach((v, k) => {
            obj[String(k)] = normalizeCborValue(v);
        });
        return obj;
    }
    if (Array.isArray(value)) {
        return value.map((v) => normalizeCborValue(v));
    }
    return value;
}

export function parseShaperChildrenBlob(blob) {
    const payload = normalizeCborValue(blob) ?? {};
    if (!payload) {
        return emptyParsed();
    }

    // Backward compatibility: legacy tuple payload
    if (Array.isArray(payload)) {
        const [topLevel = {}, top5 = [], children = {}, parentMap = {}] = payload;
        return {
            isFlat: false,
            sites: {
                top_level: normalizeCborValue(topLevel) ?? {},
                top_5_bandwidth: top5 || [],
                children: normalizeCborValue(children) ?? {},
                parent_map: normalizeCborValue(parentMap) ?? {},
            },
            circuits: null,
        };
    }

    const sites = payload.sites || {};
    const circuits = payload.circuits || null;

    return {
        isFlat: !!payload.is_flat,
        sites: {
            top_level: normalizeCborValue(sites.top_level) ?? {},
            top_5_bandwidth: sites.top_5_bandwidth || [],
            children: normalizeCborValue(sites.children) ?? {},
            parent_map: normalizeCborValue(sites.parent_map) ?? {},
        },
        circuits: circuits
            ? {
                  circuits: normalizeCborValue(circuits.circuits) ?? {},
                  top_download: circuits.top_download || [],
                  top_upload: circuits.top_upload || [],
              }
            : null,
    };
}

export function normalizeMap(value) {
    return normalizeCborValue(value);
}

export function getTopLevelItems(parsed) {
    if (!parsed) {
        parsed = emptyParsed();
    }
    const fromCircuits = parsed.circuits ? parsed.circuits.circuits || {} : {};
    const sites = parsed.sites || {};
    const topLevel = parsed.circuits ? fromCircuits : sites.top_level || {};
    const topDownload = parsed.circuits
        ? parsed.circuits.top_download || []
        : sites.top_5_bandwidth || [];
    const topUpload = parsed.circuits
        ? (parsed.circuits.top_upload && parsed.circuits.top_upload.length
              ? parsed.circuits.top_upload
              : parsed.circuits.top_download || [])
        : sites.top_5_bandwidth || [];

    return {
        isFlat: parsed.isFlat,
        topLevel,
        topDownload,
        topUpload,
        children: parsed.circuits ? {} : sites.children || {},
        parentMap: parsed.circuits ? {} : sites.parent_map || {},
    };
}
